import { render, staticRenderFns } from "./CouponReceive.vue?vue&type=template&id=79f1684b&scoped=true"
import script from "./CouponReceive.vue?vue&type=script&lang=js"
export * from "./CouponReceive.vue?vue&type=script&lang=js"
import style0 from "./CouponReceive.vue?vue&type=style&index=0&id=79f1684b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f1684b",
  null
  
)

export default component.exports